<div class="address-form flex-column g-space-md">
  @if (this.state() === 'loading') {
    <div class="address-form__loading flex-column align-center g-space-md">
      <cam-loader></cam-loader>
      <cam-text color="secondary">{{ 'core.address-form.loading' | translate }}</cam-text>
    </div>
  } @else if (this.fetchError()) {
    <cam-error [message]="'core.address-form.fetch-error' | translate"></cam-error>
  } @else {
    <div class="flex-column g-space-xs">
      <cam-input-address
        [input]="this.googleAddressInput"
        [standalone]="true"
        (valueChanged)="this.onGooglePlaceSelected($event)"
      ></cam-input-address>

      @if (this.state() === 'empty') {
        <cam-link size="sm" icon="edit" (action)="this.unlockManualMode()">
          {{ 'core.address-form.edit-manually' | translate }}
        </cam-link>
      }
    </div>

    @if (this.state() === 'locked' && this.currentPlaceId()) {
      <div class="address-form__banner flex-column g-space-sm">
        <div class="address-form__banner-info flex-row g-space-sm">
          <cam-font-icon name="check-circle" type="lg"></cam-font-icon>
          <div class="flex-column">
            <cam-text [isBold]="true">
              {{ 'core.address-form.verified' | translate }}
            </cam-text>
            <cam-text size="xs">
              {{ 'core.address-form.place-id' | translate }} · {{ this.currentPlaceId() }}
            </cam-text>
          </div>
        </div>
        @if (this.mapPoints().length > 0) {
          <div class="address-form__banner-map">
            <cam-google-maps [points]="this.mapPoints()"></cam-google-maps>
          </div>
        }
      </div>
    }

    <div class="address-form__section flex-column g-space-sm" [hidden]="this.state() === 'empty'">
      <div class="address-form__section-header flex-row space-between align-center">
        <cam-title [level]="4" [isBold]="true">
          {{ 'core.address-form.section-details' | translate }}
        </cam-title>
        @if (this.state() === 'locked') {
          <cam-badge icon="lock" type="default" value="core.address-form.read-only"></cam-badge>
        }
        @if (this.state() === 'manual') {
          <cam-badge icon="edit" type="warning" value="core.address-form.manual-mode"></cam-badge>
        }
      </div>
      <cam-form
        [inputs]="this.formInputs"
        [canDisplayButton]="false"
        [askValidation$]="this.askValidation$()"
        (valid)="this.submit()"
        (isFormValid)="this.onCamFormValidityChange($event)"
      ></cam-form>
    </div>

    @if (this.state() === 'locked') {
      <div class="address-form__bottom-action flex-row space-between align-center">
        <div class="flex-column">
          <cam-text>{{ 'core.address-form.does-not-match' | translate }}</cam-text>
          <cam-text size="xs" color="secondary">
            {{ 'core.address-form.placeid-removed-warning' | translate }}
          </cam-text>
        </div>
        <cam-button type="secondary" icon="edit" (action)="this.unlockManualMode()">
          {{ 'core.address-form.edit-manually' | translate }}
        </cam-button>
      </div>
    }

    @if (this.state() === 'manual' && this.hasSnapshot()) {
      <cam-link icon="arrow-left" (action)="this.revertToOriginal()">
        {{ 'core.address-form.revert-to-original' | translate }}
      </cam-link>
    }
  }
</div>
